import http from './http'

export function getVisitors(params) {
  return http.get('/visitors/', { params })
}

export function createVisitor(data) {
  return http.post('/visitors/', data)
}

export function importVisitors(data) {
  return http.post('/visitors/import/', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function getVisitorAssignment(counselorId) {
  return http.get('/relations/assign/', { params: { counselor_id: counselorId } })
}

export function assignVisitors(data) {
  return http.post('/relations/assign/', data)
}
